// Helpers del total de servicios reconocidos de una resolución de Reconocimiento de Servicios.
// La resolución de ANSES cierra con un total expresado en años/meses/días (ej. "21 años 8 meses
// 8 días"); el detalle por período/empresa vive en el PDF adjunto y no se modela acá.

const esVacio = (valor) => valor === null || valor === undefined || valor === '';

/**
 * Formatea el total de una resolución como texto legible ("21 años 8 meses 8 días").
 * Omite los componentes vacíos o en cero; devuelve null si no hay nada cargado.
 */
export const formatearTotalReconocido = (anios, meses, dias) => {
    if (esVacio(anios) && esVacio(meses) && esVacio(dias)) return null;
    const partes = [];
    const a = Number(anios) || 0;
    const m = Number(meses) || 0;
    const d = Number(dias) || 0;
    if (a > 0) partes.push(`${a} ${a === 1 ? 'año' : 'años'}`);
    if (m > 0) partes.push(`${m} ${m === 1 ? 'mes' : 'meses'}`);
    if (d > 0) partes.push(`${d} ${d === 1 ? 'día' : 'días'}`);
    return partes.length > 0 ? partes.join(' ') : '0 días';
};

/**
 * Suma los totales de varios reconocimientos normalizando el acarreo (30 días → 1 mes,
 * 12 meses → 1 año). Devuelve null si ninguno tiene total cargado.
 */
export const sumarTotalesReconocidos = (reconocimientos = []) => {
    const conTotal = reconocimientos.filter(r =>
        !esVacio(r?.aniosReconocidos) || !esVacio(r?.mesesReconocidos) || !esVacio(r?.diasReconocidos));
    if (conTotal.length === 0) return null;

    let anios = 0;
    let meses = 0;
    let dias = 0;
    conTotal.forEach((r) => {
        anios += Number(r.aniosReconocidos) || 0;
        meses += Number(r.mesesReconocidos) || 0;
        dias += Number(r.diasReconocidos) || 0;
    });

    meses += Math.floor(dias / 30);
    dias = dias % 30;
    anios += Math.floor(meses / 12);
    meses = meses % 12;

    return { anios, meses, dias };
};
